import { InjectionToken } from '@angular/core';
import { IdleActivityConfig } from './idle-activity-config';

export const IdleActivityConfigInjectionToken = new InjectionToken<IdleActivityConfig>('IdleActivityConfig');
